export default [
	'text_block',
	'media_block',
	'fill_in_the_blank',
	'labeling',
	'matching',
	'multiple_choice',
	'new_multiple_choice',
	'open_response',
	'new_select_all_that_apply',
	'sorting',
	'true_false',
	'numeric_response',
	'grouping',
    'hot_spot',
	'hot_text',
	'drawing',
]
